<template>
  <div class="__wrapper">
    <div class="__head"></div>
    <div class="__body">
      <div class="__container">
        <div class="profile-card">
          <div class="section section-1">
            <img src="../assets/images/vegard.jpg" v-if="false" />
            <div class="__avatar" v-else>
              <span>{{getCompany.name.substring(0, 1) | validate }}</span>
            </div>
            <div class="contents">
              <h1>Google Inc.</h1>
            </div>
          </div>
          <div class="section greyed">
            <div class="contents bordered">
              <label>Silicon Valley, USA</label>
            </div>
            <!--                            <img src="../assets/icons/location-1.svg">-->
          </div>
          <div class="section">
            <div class="contents">
              <label>+1 234 233 232</label>
              <label>abcde@gmail.com</label>
            </div>
            <!--                            <img src="../assets/icons/contact.svg">-->
          </div>
        </div>
        <div class="whole">
          <div class="__left">
            <div class="__card less">
              <div class="wrapper">
                <router-link to="/profile/consultant">
                  <div class="item-row">
                    <!--                                            <img src="../assets/icons/feed__projects.svg">-->
                    <span>Profile</span>
                  </div>
                </router-link>
                <router-link to>
                  <div class="item-row">
                    <!--                                            <img src="../assets/icons/feed_employments.svg">-->
                    <span>Customers</span>
                  </div>
                </router-link>
                <router-link to>
                  <div class="item-row">
                    <!--                                            <img src="../assets/icons/feed__skills.svg">-->
                    <span>Leads</span>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="__main">
            <div class="button">
              <span @click="gotoBuy">Manage Company Profile</span>
            </div>
            <div class="__card less">
              <div class="holder">
                <div class="title">
                  <h2>Consultants ({{consultants.length | validate }})</h2>
                </div>
                <div class="consultant" v-for="(person,i) in consultants">
                  <div class="person">
                    <img :src="$fullUrl('images/profiles/'+person.profile_picture)" />
                    <div class="content">
                      <span>{{person.first_name + " "+person.last_name | validate }}</span>
                      <div class="bar"></div>
                    </div>
                  </div>
                  <div class="button">
                    <span>Skills(0)</span>
                  </div>
                  <div class="button">
                    <span>Projects(0)</span>
                  </div>
                  <div class="date">
                    <span>12-Dec-2017</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="__card less">
              <div class="holder">
                <div class="title">
                  <h2>Projects (342)</h2>
                </div>
                <div class="projects">
                  <div class="project">
                    <label>Google data entry</label>
                    <div class="bar"></div>
                    <span>Location</span>
                    <label>Paris, France</label>
                    <div class="actions">
                      <div class="button">
                        <span>Consultants</span>
                      </div>
                      <div class="button white">
                        <span>Skills</span>
                      </div>
                    </div>
                  </div>
                  <div class="project">
                    <label>Google data entry</label>
                    <div class="bar"></div>
                    <span>Location</span>
                    <label>Paris, France</label>
                    <div class="actions">
                      <div class="button">
                        <span>Consultants</span>
                      </div>
                      <div class="button white">
                        <span>Skills</span>
                      </div>
                    </div>
                  </div>
                  <div class="project">
                    <label>Google data entry</label>
                    <div class="bar"></div>
                    <span>Location</span>
                    <label>Paris, France</label>
                    <div class="actions">
                      <div class="button">
                        <span>Consultants</span>
                      </div>
                      <div class="button white">
                        <span>Skills</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="__card less">
              <div class="holder">
                <div class="title">
                  <h2>Average Skills (1264)</h2>
                </div>
                <div class="skills">
                  <div class="skill">
                    <span>Tools</span>
                    <label>Location</label>
                  </div>
                  <div class="skill">
                    <span>Domains</span>
                    <label>Location</label>
                  </div>
                  <div class="skill">
                    <span>Competence</span>
                    <label>Location</label>
                  </div>
                  <div class="skill">
                    <span>Language</span>
                    <label>Location</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <v-layout justify-center>
        <v-dialog v-model="model" max-width="700" style="z-index: 999999!important;">
          <v-card color="#EDEDED">
            <v-layout>
              <div class="card__body">
                <div class="__cont" :class="{ __hide: !showStep1, __show : showStep1 }">
                  <h1 class="__colored">Get A 30 days free trial</h1>
                  <h3>Manage your consultants:</h3>
                  <div class="icons">
                    <div>
                      <img src="../assets/icons/icon1.svg" />
                      <h2>Profile</h2>
                    </div>
                    <div>
                      <img src="../assets/icons/icon2.svg" />
                      <h2>Skills</h2>
                    </div>
                    <div>
                      <img src="../assets/icons/icon3.svg" />
                      <h2>Availability</h2>
                    </div>
                    <div>
                      <img src="../assets/icons/icon4.svg" />
                      <h2>Leads</h2>
                    </div>
                  </div>
                  <div class="button">
                    <span @click="gotoBuy">Get started</span>
                  </div>
                </div>
                <div class="__cont" :class="{ __hide: !showStep2, __show : showStep2 }">
                  <div class="__col">
                    <h2>Personal Infos</h2>
                    <div class="__input-group">
                      <input class="__input" placeholder="Name" />
                      <input class="__input" placeholder="Surname" />
                    </div>
                    <div class="__input-group">
                      <input class="__input phone" placeholder="Phone number" />
                      <input class="__input" placeholder="E-mail address" />
                    </div>
                    <div class="btns">
                      <div class="__proceed" @click="gotoBuy">
                        <span>Proceed</span>
                      </div>
                      <div class="__cancel">
                        <span @click="showStep1 = true">Cancel</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="__indicators">
                  <div class="__circle" :class="{active : showStep1}" @click="showStep1= true"></div>
                  <div class="__circle" :class="{active : showStep2}" @click="showStep2 = true"></div>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>
<script>
import { eventBus } from "../main";
import { mapGetters, mapActions } from "vuex";
import Header from "../components/Partials/ToolBar";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "company",
  components: {
    Header,
  },

  mounted() {
    let vm = this;
    vm.getCompanyInfo();
  },
  computed: {
    ...mapGetters([
      "getLocale",
      "getLoader",
      "getCompany",
      "getMeProfile",
      "getApiUrl",
      "getMessages",
      "getCountries",
      "getHelper",
    ]),
    consultants() {
      return this.getCompany.consultants;
    },
  },
  data() {
    return {
      activeTab: 0,
      showStep1: true,
      showStep2: false,
      model: false,
      options: {
        countries: [],
      },
      loadError: false,
      loader: {
        loading: false,
        isError: false,
        message: "There was error while saving changes you made",
        backgroundColor: "#fff",
        opacity: 0.5,
        loaderType: "dots", //spinner or dots or bars
        color: "#FF9C00",
      },
    };
  },
  methods: {
    ...mapActions(["GET_ME_PROFILE_DATA"]),

    hit() {
      this.model = true;
      console.log("hello");
    },
    getMeProfileData() {
      this.$store.dispatch("GET_ME_PROFILE_DATA");
    },
    fetchCountries() {
      this.$store.dispatch("GET_COUNTRIES");
    },
    closeModal() {
      this.$refs.updatePersonalInfoModal.hide();
    },
    submitData() {
      let vm = this;
      let isFormValidObj = vm.isFormValid();
      if (isFormValidObj.valid) {
        vm.startProgressBar();
        vm.$http
          .post(
            vm.$fullUrl(vm.getHelper.api.relativeUrls.postPersonalInfoUpdate),
            {
              headline: vm.editedItem.headline,
              linked_in_url: vm.editedItem.linked_in_url,
              web_site: vm.editedItem.web_site,
              first_name: vm.editedItem.first_name,
              last_name: vm.editedItem.last_name,
              country: vm.editedItem.country,
              city: vm.editedItem.city,
              username: vm.editedItem.username,
              email: vm.editedItem.email,
              overview: vm.editedItem.overview,
            },
            {
              headers: { Authorization: "Bearer " + sessionStorage.authToken },
            }
          )
          .then(function (response) {
            // console.log(response)
            vm.getMeProfileData();
            vm.closeModal();
            // vm.meProfileData = response.data
          })
          .catch((error) => {
            console.log(error);
            vm.loader.isError = true;
          })
          .finally(() => {
            vm.stopProgressBar();
          });
      } else {
        vm.loader.isError = true;
        vm.loader.message = isFormValidObj.field + " is required";
      }
    },
    startProgressBar() {
      this.$store.dispatch("LOADER_START");
      this.$store.dispatch("LOADER_SUCCESS");
      this.$store.dispatch("LOADER_MESSAGE");
    },
    stopProgressBar() {
      // this.loader.loading = false
      this.$store.dispatch("LOADER_CLOSE");
    },
    getCompanyInfo() {
      this.$store.dispatch("GET_COMPANY_INFO", { id: this.$route.params.id });
    },
    gotoBuy() {
      this.$router.push({
        name: "purchase-company",
        params: { id: this.$route.params.id },
      });
    },
  },
  watch: {
    showStep1: function (val) {
      if (val) this.showStep2 = false;
    },
    showStep2: function (val) {
      if (val) this.showStep1 = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/main";

$dashboard-stats-border-radius: 16px;
* {
  box-sizing: border-box;
}
.__indicators {
  display: flex;
  position: absolute;
  bottom: 20px;
  left: 45%;
  width: 50px;
  justify-content: space-between;
  .__circle {
    width: 13px;
    cursor: pointer;
    height: 13px;
    border-radius: 100px;
    border: 1px solid #707070;
    background: transparent;
  }
  .active {
    background: #707070;
  }
}
.__wrapper {
  background: #f5f9fc;
  min-height: 93%;
  .__head {
    height: 80px;
    background: url("../assets/icons/rainbow.svg") no-repeat;
    background-size: cover;
    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }
  }
  .__body {
    .__container {
      width: 70%;
      margin: 0 auto;
      .profile-card {
        display: grid;
        margin-top: -20px;
        border-radius: 5px;
        box-shadow: 0 7px 6px rgba(0, 0, 0, 0.16);
        margin-bottom: 20px;
        background: #ffffff;
        grid-template-columns: 1fr 1fr 1fr;
        .section {
          display: flex;
          text-align: center;
          padding: 10px 20px;
          flex-direction: column-reverse;
          .contents {
            display: flex;
            flex-direction: column;
            h1 {
              font-size: 22px;
              color: #1885ad;
              font-weight: normal;
              margin-bottom: 0;
            }
            h3 {
              font-size: 14px;
              font-weight: lighter;
              color: #646262;
              margin-top: 5px;
            }
            label {
              color: #6e6e6e;
              font-size: 14px;
              margin-bottom: 0;
              font-weight: lighter;
              margin-top: 0;
            }
          }

          img {
            margin-bottom: 20px;
          }
        }
        .section-1 {
          text-align: left;
          display: flex;
          flex-direction: row;
          img,
          .__avatar {
            width: 80px;
            border-radius: 100%;
            margin-right: 10px;
            height: 80px;
            padding: 3px;
            background: #fff;
            margin-top: -40px;
            margin-bottom: 0;
          }
          .__avatar {
            display: flex;
            overflow: hidden;
            padding-bottom: 20px;
            justify-content: center;
            align-items: center;
            border: 5px solid #fff;
            background: url("../assets/icons/rainbow.svg") no-repeat;
            background-size: cover;
            span {
              font-size: 105px;
              color: #fff;
            }
          }
          .contents {
            display: flex;
            flex-direction: column-reverse;
          }
        }
      }
      .whole {
        display: grid;
        grid-template-columns: 1fr 3fr;
        grid-column-gap: 10px;
        .__left {
          h2 {
            color: #535353;
            margin-top: 20px;
            margin-left: 10px;
            font-size: 23px;
          }
          a:hover {
            text-decoration: none !important;
          }
          .item-row {
            padding: 20px;
            &:hover {
              background: #e5e5e5;
            }
            img {
              margin-right: 20px;
            }
            span {
              color: #1885ad;
              font-size: 14px;
              font-weight: normal;
            }
          }
          .__body {
            display: flex;
            flex-direction: column;
            padding: 10px;
            h3 {
              font-size: 16px;
              color: #000;
              margin-top: 10px;
              margin-bottom: 30px;
            }
            .__item {
              margin-bottom: 10px;
              label {
                color: #6e6e6e;
                font-size: 14px;
                font-weight: lighter;
              }
            }
          }
        }
        .__main {
          .button {
            width: 80%;
            margin: 0 auto;
            background: #1ba5a4;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            margin-bottom: 20px;
            border-radius: 5px;
            span {
              color: #fff;
              cursor: pointer;
            }
          }
          .holder {
            padding: 20px 40px;
            .title {
              padding-bottom: 15px;
              border-bottom: 0.5px solid rgba(112, 112, 112, 0.8);
              margin-bottom: 20px;
              h2 {
                color: #6e6e6e;
                font-size: 20px;
                font-weight: normal;
              }
            }
            .consultant {
              display: grid;
              padding-left: 20px;
              margin-bottom: 10px;
              padding-right: 20px;
              padding-top: 10px;
              border: 0.5px solid rgba(112, 112, 112, 0.4);
              border-radius: 5px;
              grid-template-columns: 1.5fr 1fr 1fr 1fr;
              .person {
                display: flex;
                img {
                  width: 42px;
                  height: 42px;
                  border-radius: 100%;
                }
                .content {
                  display: flex;
                  margin-left: 10px;
                  flex-direction: column;
                  color: #535353;
                  font-weight: normal;
                  font-size: 13px;
                  span {
                    margin-top: 3px;
                  }
                  .bar {
                    background: #1885ad;
                    border-radius: 3px;
                    width: 20px;
                    margin-top: 8px;
                    height: 5px;
                  }
                }
              }
              .button {
                background: #bebebe;
                height: 25px;
                font-size: 12px;
                margin-top: 5px;
                margin-bottom: 0 !important;
                span {
                  color: #fff;
                }
              }
              .date {
                text-align: center;
                padding-top: 8px;
                color: #959595;
                font-size: 13px;
              }
            }
            .projects {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              grid-column-gap: 20px;
              .project {
                display: flex;
                flex-direction: column;
                border: 0.5px solid rgba(112, 112, 112, 0.4);
                padding: 10px;
                border-radius: 5px;
                label {
                  font-size: 16px;
                  color: #535353;
                }
                span {
                  color: #959595;
                  margin-top: 10px;
                  font-size: 14px;
                }
                .bar {
                  background: #1885ad;
                  border-radius: 3px;
                  width: 20px;
                  margin-top: 8px;
                  height: 5px;
                }
                .actions {
                  margin-top: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  justify-content: space-between;
                  .button {
                    height: 20px;
                    background: #959595;
                    cursor: pointer;
                    margin: 0;
                    &:hover {
                      background: #fff !important;
                      border: 0.5px solid rgba(112, 112, 112, 0.4) !important;
                      span {
                        color: #959595 !important;
                      }
                    }
                    span {
                      color: #fff;
                      margin-top: 1px;
                      font-size: 11px;
                    }
                  }
                  .white {
                    background: #fff;
                    border: 0.5px solid rgba(112, 112, 112, 0.4) !important;
                    &:hover {
                      background: #1885ad !important;
                      span {
                        color: #fff !important;
                      }
                    }
                    span {
                      color: #959595;
                      margin-top: 1px;
                    }
                  }
                }
              }
            }
            .skills {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr 1fr;
              grid-column-gap: 20px;
              .skill {
                display: flex;
                text-align: center;
                flex-direction: column;
                span {
                  color: #959595;
                  font-size: 14px;
                  margin-bottom: 20px;
                }
                label {
                  border: 0.5px solid rgba(112, 112, 112, 0.4);
                  color: #000000;
                  font-size: 17px;
                  text-align: left;
                  border-radius: 5px;
                  padding: 7px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.__green {
  color: #1ba5a4;
}
.__hide {
  opacity: 0;
  pointer-events: none;
  animation: slide-out 0.9s forwards;
  -webkit-animation: slide-out 0.9s forwards;
}
.__show {
  opacity: 1;
  pointer-events: auto;
  /*animation: slide-in 0.5s forwards;*/
  /*-webkit-animation: slide-in 0.5s forwards;*/
}
.__blue {
  color: #1885ad;
}
.card__body {
  padding: 20px;
  height: 400px;
  width: 100%;
  position: relative;
  .__cont {
    position: absolute;
    top: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    left: 0;
    h1 {
      color: #1999a7;
      text-align: center;
      margin-top: 30px;
      font-size: 32px;
    }
    h3 {
      color: #1885ad;
      font-size: 22px;
      margin-top: 40px;
      margin-bottom: 40px;
      text-align: center;
    }
    .icons {
      display: flex;
      justify-content: space-between;
      width: 80%;
      margin: 0 auto;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        h2 {
          color: #707070;
          font-size: 24px;
          margin-bottom: 30px;
        }
        img {
          width: 40px;
          text-align: center;
          height: 40px;
          margin-bottom: 20px;
          margin-top: 20px;
        }
      }
    }
    .button {
      background: #1885ad;
      color: #fff;
      border-radius: 5px;
      display: flex;
      cursor: pointer;
      width: 30%;
      margin: 0 auto;
      padding: 10px;
      align-items: center;
      justify-content: center;
      span {
        color: #fff;
      }
    }
  }
}
.__col {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 10%;
  h2 {
    font-size: 26px;
    color: #2c2c2c;
    margin-bottom: 30px;
  }
  .__input-group {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    .__input {
      color: #939393;
      background: #fff;
      padding: 8px 10px;
      width: 100%;
      margin-right: 10px;
      border-radius: 5px;
      outline: none;
      box-shadow: 0 3px 2px rgba(0, 0, 0, 0.16);
    }
  }
  .btns {
    display: flex;
    .__proceed {
      background: #1885ad;
      padding: 10px 20px;
      color: #fff;
      cursor: pointer;
      border-radius: 5px;
    }
    .__cancel {
      padding: 10px 20px;
      cursor: pointer;
      color: #3d98b9;
    }
  }
}
.__card {
  background: #fff;
  padding: 20px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);
}
.less {
  padding: 0 !important;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
}
.greyed {
  background: #f8f8f8;
}
</style>
